import axios from "axios";

export const apiDefault = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json"
  }
});
